module.exports = __webpack_public_path__ + "img/home--active.21666cc3.svg";